module.exports = __webpack_public_path__ + "static/img/13.7f9dafd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/zh/13.png
// module id = z45V
// module chunks = 0